<template>
  <kudo-card>
    <kudo-block class="flex flex-col gap-y-4">
      <div class="flex justify-between items-center">
        <p class="font-medium text-base">
          Dates and States
        </p>
        <nuxt-link :to="DATES_AND_STATES_STEP_PATH">
          <kudo-button
            color-variant="flat"
            shape-variant="thin"
            class="!p-1 !py-0"
          >
            <i class="far fa-edit" />
            Edit
          </kudo-button>
        </nuxt-link>
      </div>
      <div
        v-for="(locationDate, index) in datesAndStatesFormData.locationDates"
        :key="index"
        class="flex flex-col gap-y-2"
      >
        <div>
          <span class="text-sm text-gray-dark mr-1">
            {{ dayjs(locationDate.startDate).format('MM/DD/YYYY') }} - {{ dayjs(locationDate.endDate).format('MM/DD/YYYY') }}
          </span>
          <kudo-pill
            v-if="locationDate.type === openlyCatTypeOption.value"
            class="ml-1"
            :class="{ 'bg-blue-lighter': locationDate.type === pcsTypeOption.value, 'bg-gold-light': locationDate.type === openlyCatTypeOption.value}"
          >
            {{ locationDate.type === pcsTypeOption.value ? 'PCS' : 'Openly Only' }}
          </kudo-pill>
        </div>
        <div>
          <kudo-pill
            v-for="(state, stateIndex) in locationDate.states"
            :key="stateIndex"
            class="mr-1 border border-gray-darker"
          >
            <span class="min-w-6 text-center">{{ state }}</span>
          </kudo-pill>
        </div>
      </div>
    </kudo-block>
  </kudo-card>
</template>

<script setup>
import dayjs from 'dayjs'
import { KudoCard, KudoButton, KudoBlock, KudoPill } from '@openly-engineering/kudo'
import { DATES_AND_STATES_STEP_PATH, pcsTypeOption, openlyCatTypeOption } from './cat-tag-utils'

const { $store } = useNuxtApp()
const datesAndStatesFormData = computed(() => $store.getters['adminClaims/getFormDataByStepPath'](DATES_AND_STATES_STEP_PATH))
</script>
